import {
  AccountBalance,
  AdminPanelSettings,
  Cancel,
  Gavel,
  Language,
  Payment,
  Person,
  PlayCircleOutline,
  Policy,
  Receipt,
  Report,
  Savings,
  Settings,
  WarningAmber,
  WorkOutline,
} from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

export interface AdminNavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
}

/** Shared admin navigation — profile menu, mobile drawer, and Command Center sidebar. */
export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  { label: 'Admin Hub', path: '/admin', icon: AdminPanelSettings },
  { label: 'Profile', path: '/profile', icon: Person },
  { label: 'Settings', path: '/settings', icon: Settings },
  { label: 'Open Service Requests', path: '/admin/open-service-requests', icon: WorkOutline },
  { label: 'Financials', path: '/admin/financials', icon: AccountBalance },
  { label: 'Weekly Payouts', path: '/admin/payouts', icon: Payment },
  { label: 'Payments Attention', path: '/admin/payments-requiring-attention', icon: WarningAmber },
  { label: 'Good Faith Payment', path: '/admin/good-faith-payment', icon: Gavel },
  { label: 'Cancellations', path: '/admin/cancellations', icon: Cancel },
  { label: 'Service Search', path: '/admin/services/search', icon: Receipt },
  { label: 'Compliance', path: '/admin/compliance', icon: Policy },
  { label: 'Compliance & Reports', path: '/admin/reports', icon: Report },
  { label: 'Savings Leads', path: '/admin/provider-savings-leads', icon: Savings },
  { label: 'Demo Requests', path: '/admin/demo-requests', icon: PlayCircleOutline },
  { label: 'Website Settings', path: '/admin/website-settings', icon: Language },
];

export const ADMIN_SIDEBAR_EXPANDED_WIDTH = 248;
export const ADMIN_SIDEBAR_COLLAPSED_WIDTH = 64;
export const ADMIN_SIDEBAR_STORAGE_KEY = 'lawnhub.adminQuickAccess.collapsed';

/** Same breakpoint as provider Command Center. */
export const ADMIN_SIDEBAR_MIN_WIDTH_PX = 768;
